import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";

/**
 * Sticky CTA mobile no bottom. Aparece após o user passar a primeira dobra (~600px).
 * Não renderiza em desktop (md+).
 */
export const ParceirosStickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToForm = () => {
    const el = document.getElementById("form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 pt-3 bg-gradient-to-t from-[#FAF8F5] via-[#FAF8F5]/95 to-[#FAF8F5]/0 transition-opacity duration-200 ${
        visible
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
      }`}
    >
      <button
        type="button"
        onClick={scrollToForm}
        className="w-full inline-flex items-center justify-center gap-2 rounded-full font-semibold text-sm h-12 bg-[#112711] hover:bg-[#1F4A33] text-white shadow-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#112711]"
      >
        Quero conhecer o programa
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
};
